import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  setNotificationCount,
  tryGetRecieverCount,
} from '../../../redux/slices/notificationSlice'
import CustomModal from 'components/CustomModal'
import CustomIcon from 'components/CustomIcon'

const NotificationCountConfirmationModal = ({
  onConfirm,
  showModal,
  setShowModal,
  isSchedule = false,
}) => {
  const dispatch = useDispatch()

  const {
    count: { value, deviceCount, loading },
    processing,
  } = useSelector((state) => state.notification)

  useEffect(() => {
    if (!!showModal && !showModal?.mobile?.length) {
      dispatch(
        tryGetRecieverCount({
          filters: showModal?.filters,
          filter_type: showModal?.filter_type,
          type:
            showModal?.action && showModal.action.length
              ? showModal.action
              : showModal.type,
        }),
      )
    }
  }, [showModal])

  const FocusedText = ({ children }) => {
    return (
      <span className="font-black px-1 py-0.5 bg-blue-100 rounded">
        {children}
      </span>
    )
  }
  return (
    <CustomModal
      title={isSchedule ? 'Schedule Notification' : 'Send Notification'}
      showModal={!!showModal && (!loading || showModal.mobile.length)}
      setShowModal={() => {
        setShowModal()
        dispatch(setNotificationCount())
      }}
      loading={processing}
      disabled={(!value && value === 0) || processing}
      onClick={() => {
        onConfirm({
          ...showModal,
          receivers_count: showModal?.mobile?.length
            ? showModal.mobile.length
            : value,
          ...(deviceCount && { devices_count: deviceCount }),
        })
      }}
      bodyClasses="max-w-md"
      buttonLabel={isSchedule ? 'Schedule' : 'Send'}
    >
      <div className="flex items-start space-x-2 py-4">
        <CustomIcon
          icon="circle_notifications"
          className="text-secondary-500 mb-4"
          size="5xl"
        />
        <div className="text-lg leading-relaxed">
          {(!!deviceCount || deviceCount === 0)? (
            <FocusedText>
              {deviceCount}&nbsp;active user{deviceCount > 1 ? 's' : ''}
            </FocusedText>
          ) : <></>}
          {((!!value || value === 0) && (!!deviceCount || deviceCount === 0)) && <> & </>}
          {(!!value || value === 0 || showModal?.mobile?.length > 0) ? (
            <FocusedText>
              {showModal?.mobile?.length ? showModal.mobile.length : value}
              &nbsp;total user{value > 1 ? 's' : ''}
            </FocusedText>
          ) : <></>}
          will receive this notification.
          {value ? (
            ` Would you like to ${isSchedule ? 'schedule' : 'send'} it?`
          ) : (
            <></>
          )}
        </div>
      </div>
    </CustomModal>
  )
}

export default NotificationCountConfirmationModal
